
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";

@Component({
  props: {
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    cancelarLabel: {
      type: String,
      default: "Não",
    },
    aprovarLabel: {
      type: String,
      default: "Sim",
    },
  },
})
export default class QuestionDialogComponent extends Vue {
  private dlgVisible = false;
  private internalPayload;

  private internalLabels = {
    title: this.$props.title,
    message: this.$props.message,
    cancelar: this.$props.cancelarLabel,
    aprovar: this.$props.aprovarLabel,
  };

  show(
    payload?: any,
    label?: {
      title: string;
      message: string;
      cancelarLabel?: string;
      aprovarLabel?: string;
    }
  ) {
    this.dlgVisible = true;
    this.internalPayload = payload;
    this.internalLabels = { ...this.internalLabels, ...label };
  }

  @Watch("dlgVisible")
  onDlgClosedByEscKey(value: boolean, oldValue: boolean) {
    // if (value === false) {
    //   this.onCancelarClick();
    // }
  }

  onAprovarClick() {
    this.dlgVisible = false;
    this.$emit("aprovarClick", this.internalPayload);
  }

  onCancelarClick() {
    this.dlgVisible = false;
    this.$emit("cancelarClick");
  }
}
